import {Component, Input, OnInit} from '@angular/core';
import {StepService} from '../../services/step.service';
import {Router} from '@angular/router';
import {ElementService} from '../../services/element.service';
import {DecimalPipe} from '@angular/common';
import {EingabeStepComponent} from '../eingabe/eingabe.step.component';
import {PortalService} from '../../services/portal.service';
import {MatDialog} from '@angular/material/dialog';
import {ThermostatcheckRequestService} from "../services/request.service";

/**
 *
 */
@Component({
    selector: 'app-thermostatcheck-ergebnis',
    templateUrl: './ergebnis.component.html',
    providers: [DecimalPipe],
    standalone: false
})
export class ErgebnisComponent extends EingabeStepComponent implements OnInit {

  /**
   * textkey prefix
   */
  @Input() textkeyPrefix: string = "thermostatcheck.ergebnis";

  /**
   * all thermostat types for tab module
   */
  thermostatTypes: any = ['info', 'manuell', 'programmierbar', 'smart'];

  /**
   * current portalId
   */
  portalId: string;

  /**
   * will be set to true if there is an error while talking to the backend.
   */
  hasError = false;

  /**
   * toggle if this is an internal project or not.
   */
  internalPortal: boolean;

  /**
   * hide report download
   */
  hideReportDownload: boolean;

  /**
   * URL for the report to download
   */
  reportUrl: string;

  /**
   * URL for showing the HEC
   */
  hecUrl: string;

  /**
   * toggle if we want to display the download module
   */
  showDownload: boolean;

  /**
   * @inheritDoc
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: ThermostatcheckRequestService,
              protected elementService: ElementService, protected portalService: PortalService,
              public dialog: MatDialog) {
    super(stepService, router, requestService, elementService, portalService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    if(!this.anfrage.result || Object.keys(this.anfrage.result).length === 0) {
      this.hasError = true;
    }

    // get the current portalId
    this.portalId = this.portalService.currentPortalId;
    this.internalPortal = this.portalService.isInternalPortal();


    //check if there is a report url
    this.reportUrl = this.anfrage.result?.report ?? null;

    // download module
    this.hideReportDownload = this.portalService.getConfigAsBool('embed.newsletter.report.download');
    this.showDownload = !this.hideReportDownload && this.reportUrl != null;

    // init url to lead to hec
    this.hecUrl = this.portalService.getConfig("alladvisors.link.heizcheck")?.replace(/\{\{portalId}}/, this.portalService.currentPortalId);
  }

}
